import { ListChecksIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const FilterCheck = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ListChecksIcon size={Sizes[size]} {...rest} color={fill} />;
};

FilterCheck.displayName = 'FilterCheck';
